import BaseStore from 'fluxible/addons/BaseStore';

class AbStore extends BaseStore {

  constructor(dispatcher) {
    super(dispatcher);
    this.winningVariants = null;
    this.abExperiments = null;
  }

  getAbExperiments() {
    return this.abExperiments;
  }

  getDocExperiments() {
    // Doc Experiments exists outside of the AB Framework
    // This might be needed for variants that exceed the scope of A&B
    return this.docExperiments;
  }

  getWinningVariants() {
    return this.winningVariants;
  }

  getWinningVariant(experimentName) {
    const winnerVariant =
      this.winningVariants && this.winningVariants.find(e => e.experiment === experimentName);

    if (!winnerVariant) {
      return null;
    }

    return winnerVariant.name;
  }

  handleAbDataLoaded(payload) {
    this.winningVariants = payload.winningVariants;
    this.abExperiments = payload.abExperiments;
    this.docExperiments = payload.docExperiments;
    this.emitChange();
  }

  dehydrate() {
    return {
      winningVariants: this.winningVariants,
      abExperiments: this.abExperiments,
      docExperiments: this.docExperiments
    };
  }

  rehydrate(state) {
    this.winningVariants = state.winningVariants;
    this.abExperiments = state.abExperiments;
    this.docExperiments = state.docExperiments;
  }
}

AbStore.storeName = 'AbStore';
AbStore.handlers = {
  LOAD_AB_DATA: 'handleAbDataLoaded'
};

export default AbStore;
